import React from 'react'
import { Link } from '@reach/router'
import { Badge, LazyLoad } from '../../common/Functions'

function Home_Works() {
  return (
  <section className="bg-gray-100">
    <div className="max-w-screen-xl	mx-auto text-center">
      <p className="font-bold text-sm py-6">MY WORKS</p>
      <div className="mx-auto pb-6">
        <div className="flex flex-wrap -mx-1 lg:-mx-4">
         <Link to="/works/seeyoudoc" className="my-1 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3 transform hover:-translate-y-5 transition ease-in-out duration-700">
          <article className="home-works-card overflow-hidden rounded-lg shadow-lg bg-white">
            <div className="home-works-banner px-20 flex items-center justify-center">
              <LazyLoad src={require('../../common/images/home/seeyoudoc.svg')} alt="Seeyoudoc Logo" className="block h-auto w-full" />
            </div>
            <header className="flex items-center justify-between leading-tight p-2 md:p-4">
              <div className="content text-left">
                <h1 className="text-lg font-bold py-5">
                  SeeYouDoc
                </h1>
                <p className="h-24 text-xs text-left text-gray-600">
                    SeeYouDoc is a platform built for patients, doctors, and healthcare providers. It is intended to provide a better healthcare services in the Philippines. Patients can search, book, and have an online consultation with doctors. Doctors, clinics, and hospital admin can manage virtual clinic profile, schedules, and online appointments with the patients. Other features that the system provides are electronic medical records, e-wallet for payments, and web portals for doctors, clinics, and hospital admins.
                </p>
              </div>
            </header>
            <footer className="h-24 flex flex-wrap items-center p-2 md:p-4">
              <Badge title="Product Management" />
              <Badge title="UX/UI Design" />
              <Badge title="Branding" />
              <Badge title="Web & Mobile Application" />
            </footer>
          </article>
          </Link>
         <Link to="/works/aims" className="my-1 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3 transform hover:-translate-y-5 transition ease-in-out duration-700">
            <article className="home-works-card overflow-hidden rounded-lg shadow-lg bg-white">
              <div className="home-works-banner px-20 flex items-center justify-center">
                <LazyLoad src={require('../../common/images/home/aims.png')} alt="Seeyoudoc Logo" className="block h-auto w-24" />
             </div>
              <header className="flex items-center justify-between leading-tight p-2 md:p-4">
                <div className="content text-left">
                  <h1 className="text-lg font-bold py-5">
                    AIMS
                  </h1>
                  <p className="h-24 text-xs text-left text-gray-600">
                    The Alumni Information Management System (AIMS) is a web application that allows all Miriam College (MC) Alumni to be able to access their accounts and information, and for MC Alumni Administrators to be able to manage alumni information, send multiple email newsletters, announcements, and generate reports.
                  </p>
                </div>
              </header>
              <footer className="h-24 flex flex-wrap items-center p-2 md:p-4">
                <Badge title="Project Management" />
                <Badge title="UX/UI Design" />
                <Badge title="Web Application" />
              </footer>
            </article>
          </Link>
         <Link to="/works/eo-ph" className="my-1 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3 transform hover:-translate-y-5 transition ease-in-out duration-700">
            <article className="home-works-card overflow-hidden rounded-lg shadow-lg bg-white">
              <div className="home-works-banner px-20 flex items-center justify-center">
                <LazyLoad src={require('../../common/images/home/eo.png')} alt="Seeyoudoc Logo" className="block h-auto w-48" />
             </div>
              <header className="flex items-center justify-between leading-tight p-2 md:p-4">
                <div className="content text-left">
                  <h1 className="text-lg font-bold py-5">
                    EO PH
                  </h1>
                  <p className="h-20 text-xs text-left text-gray-600">
                    Admin Web Portal allows the EO PH Administrators to be able to manage events, posts, video, users, as well as viewing payment history and calendar of activities. On the other hand, the Member Mobile Application allows members to read new posts, watch videos, attend events, and edit personal information.
                  </p>
                </div>
              </header>
              <footer className="h-24 flex flex-wrap items-center p-2 md:p-4">
                <Badge title="Project Management" />
                <Badge title="UX/UI Design" />
                <Badge title="Web & Mobile Application" />
              </footer>
            </article>
          </Link>
        </div>
        <div className="flex flex-wrap -mx-1 lg:-mx-4">
         <Link to="/works/nac-cmc-omt" className="my-1 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3 transform hover:-translate-y-5 transition ease-in-out duration-700">
            <article className="home-works-card overflow-hidden rounded-lg shadow-lg bg-white">
              <div className="home-works-banner px-20 flex items-center justify-center">
                <LazyLoad src={require('../../common/images/home/nac.png')} alt="Seeyoudoc Logo" className="block h-auto w-24" />
              </div>
              <header className="flex items-center justify-between leading-tight p-2 md:p-4">
                <div className="content text-left">
                  <h1 className="text-lg font-bold py-5">
                    NAC CMC - OMT
                  </h1>
                  <p className="h-24 text-xs text-left text-gray-600">
                    Nickel Asia Corp. - Cagdianao Mining Corporation - Operation Management Tool (NAC CMC - OMT) is a web application that aims to provide a simple, yet effective user experience for Cagdianao Mining Corporation (CMC) encoders and administrators who will be using web portal. The application aims to allow all CMC encoders to access their account and log entries. On the other hand, CMC administrators can manage the web portal, log entries, and generate reports.
                  </p>
                </div>
              </header>
              <footer className="h-24 flex flex-wrap items-center p-2 md:p-4">
                <Badge title="Project Management" />
                <Badge title="UX/UI Design" />
                <Badge title="Web & Mobile Application" />
              </footer>
            </article>
          </Link>
         <Link to="/works/case-evict" className="my-1 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3 transform hover:-translate-y-5 transition ease-in-out duration-700">
            <article className="home-works-card overflow-hidden rounded-lg shadow-lg bg-white">
              <div className="home-works-banner px-20 flex items-center justify-center">
                <LazyLoad src={require('../../common/images/home/caseevict.svg')} alt="Seeyoudoc Logo" className="block h-auto w-40" />
             </div>
              <header className="flex items-center justify-between leading-tight p-2 md:p-4">
                <div className="content text-left">
                  <h1 className="text-lg font-bold py-5">
                    Case Evict
                  </h1>
                  <p className="h-24 text-xs text-left text-gray-600">
                    Case Evict is a tenant-landlord case management system. The system allows clients to create their account, search for law agencies who will be handling and managing their case related to the property. Law agencies can also create their own profile, and manage their clients' cases.
                  </p>
                </div>
              </header>
              <footer className="h-24 flex flex-wrap items-center p-2 md:p-4">
                <Badge title="UX/UI Design" />
                <Badge title="Branding" />
                <Badge title="Web Application" />
              </footer>
            </article>
          </Link>
         <Link to="/works/drapshop" className="my-1 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3 transform hover:-translate-y-5 transition ease-in-out duration-700">
            <article className="home-works-card overflow-hidden rounded-lg shadow-lg bg-white">
              <div className="home-works-banner px-20 flex items-center justify-center">
                <LazyLoad src={require('../../common/images/home/drapshop.svg')} alt="Seeyoudoc Logo" className="block h-auto w-80" />
             </div>
              <header className="flex items-center justify-between leading-tight p-2 md:p-4">
                <div className="content text-left">
                  <h1 className="text-lg font-bold py-5">
                    Drapshop
                  </h1>
                  <p className="h-24 text-xs text-left text-gray-600">
                    Drapshop is an online ordering and delivery system for customers, restaurants or grocery store owners, and drivers. Customers can create account, search and order food items or groceries, and rate store and driver; Restaurant or grocery store owners can create their own profile, list their product menu, and handles customer orders; and Drivers can accept the delivery of food items, and collect payments.
                  </p>
                </div>
              </header>
              <footer className="h-24 flex flex-wrap items-center p-2 md:p-4">
                <Badge title="UX/UI Design" />
                <Badge title="Branding" />
                <Badge title="Web & Mobile Application" />
              </footer>
            </article>
          </Link>
        </div>
      </div>
    </div>
</section>
  );
}

export default Home_Works;
